import { render, staticRenderFns } from "./printer-queue.vue?vue&type=template&id=309da7b4"
import script from "./printer-queue.vue?vue&type=script&lang=js"
export * from "./printer-queue.vue?vue&type=script&lang=js"
import style0 from "./printer-queue.vue?vue&type=style&index=0&id=309da7b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports